import React from 'react';

function occupantLabel(occ) {
  if (!occ) return '—';
  return occ.username || occ.botLabel || '?';
}

/** Per-player Hearts scores (lowest wins). No bags. */
function HeartsScoreboard({
  scoreboard,
  settings,
  seats,
  compact = false,
  variant = 'panel',
}) {
  const rootClass = [
    'spades-scoreboard',
    'hearts-scoreboard',
    compact ? 'spades-scoreboard--compact' : '',
    variant === 'on-table' ? 'spades-scoreboard--on-table' : '',
    variant === 'dock' ? 'spades-scoreboard--dock' : '',
  ].filter(Boolean).join(' ');

  if (!scoreboard || !settings) {
    return (
      <div className={`${rootClass} spades-scoreboard--empty`}>
        {!compact && <h3>Hearts</h3>}
        <p className="spades-scoreboard-hint">
          {settings
            ? `Play to ${settings.winAt} · lowest wins`
            : 'Scores appear when a game starts'}
        </p>
      </div>
    );
  }

  const { hand, players } = scoreboard;

  return (
    <div className={rootClass}>
      <h3>{compact ? `H${hand || 0}` : `Hearts · Hand ${hand || 0}`}</h3>
      {!compact && (
        <p className="spades-scoreboard-mode">
          Lowest wins · to {settings.winAt}
        </p>
      )}
      <ul className="spades-scoreboard-singles">
        {['north', 'east', 'south', 'west'].map((seat) => {
          const occ = seats?.[seat];
          if (!occ) return null;
          const ps = players?.[seat];
          return (
            <li key={seat}>
              <span>{occupantLabel(occ)}</span>
              <span className="spades-score-value">{ps?.score ?? 0}</span>
              {ps?.handPoints != null && (
                <span className="hearts-hand-pts" title="This hand so far">
                  {` (${ps.handPoints})`}
                </span>
              )}
            </li>
          );
        })}
      </ul>
      {!compact && (
        <p className="spades-scoreboard-rules">
          ♥ = 1 · Q♠ = 13 · moon {settings.moonMode === 'subtract' ? '−26' : '+26 each'}
        </p>
      )}
    </div>
  );
}

export default HeartsScoreboard;
